var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sidebar-jon" }, [
    _c("div", { staticClass: "sidebar-jon--avatar" }, [
      _c(
        "div",
        [_c("Jon"), _vm._v(" "), _c("div", { staticClass: "arrow-down" })],
        1
      ),
      _vm._v(" "),
      _c("div", [_vm._v("Skilly hilft dir gerne weiter:")])
    ]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "sidebar-jon--items" },
      _vm._l(_vm.messages, function(message, i) {
        return _c(
          "li",
          {
            key: "message-" + i,
            class: "sidebar-jon--item sidebar-jon--item-" + i
          },
          [_c("span", { domProps: { innerHTML: _vm._s(message) } })]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }